import { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';

export class userCreateSelectors {
  public static selectIsUserCreateLoading = (state: IState): boolean =>
    state.modules['user-management']['user-create'].isLoading;
}
